import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/indexHome.vue')
  },
  {
    path: 'resetPassword',
    name: 'resetPassword',
    component: () => import('../views/resetPassword.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
